import { useEffect, useState, useRef } from "react";
// import VendorMoving from "../../Vendors/VendorMoving";
import VendorMoving from "../../../CompanyAdmin/VendorResponse/VendorMoving";
// import BottomNavigationVendor from "../BottomNavigationVendor/BottomNavigationVendor";
import BottomNavigationVendor from "../../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor";
import assignedTask from '../../../../Assets/assignedTask.png'
import comingCrane from '../../../../Assets/comingCrane.png'
import checksuccess from '../../../../Assets/checksuccess.png'
// import NoDataFound from '../../User/Cards/NoDataFound';
import NoDataFound from "../../../../Component/Customers/Cards/NoDataFound";
import axios from "axios";
import crossUser from '../../../../Assets/crossUser.png'
import searchinterfacesymbol from '../../../../Assets/search-interface-symbol.png'
import filterUser from '../../../../Assets/filterUser.png'
// import Modal from "../../Location1/Modal";
import Modal from "../../../../Component/CompanyAdmin/Location1/Modal";
import historyUser from '../../../../Assets/historyUser.png'
import workDoneUser from '../../../../Assets/workDoneUser.png'
import reachedUser from '../../../../Assets/reachedUser.png'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
// import { Filter } from "lucide-react";
import icon11 from '../../../../Assets/crane/icon11.svg'

import {
    CheckCircle,
    XCircle,
    CalendarDays,
    Calendar,
    Clock,
    History,
    Download,
} from "lucide-react";

function haversine(lat1, lon1, lat2, lon2) {
    console.log("accident latitude", lat1)
    console.log("accident longtitude", lon1)
    console.log("vehicle latitiude", lat2)
    console.log("vehicle longtitude", lon2)

    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; // Earth radius in km

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
}

const CraneCompletedOrders = ({ data }) => {
    const [totalCompletedCases, setTotalCompletedCase] = useState([]);
    const [spareUseData, setSpareUseData] = useState([]);

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    console.log('totalCompletedCases', totalCompletedCases[0])

    const [openDetails, setOpenDetails] = useState(false);
    const [choosenCase, setChoosenCase] = useState([])
    const [isHistoryPage, setIsHistoryPage] = useState(false);

    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [distance, setDistances] = useState([])

    const [filter, setFilter] = useState('')
    const [openFilterModal, setOpenFilterModal] = useState(false)

    const [currentStage, setCurrentStage] = useState([]); // Example stage
    const [avg, setAvg] = useState([])

    const stages = [
        { label: "Processing", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png' },
        { label: "Customer Accepted", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png' },
        { label: "Complete Order", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' },
    ];


    useEffect(() => {
        setTotalCompletedCase(data)
        setSpareUseData(data)
        if (choosenCase.length > 0) {
            const updatedCase = data.find((item) => item.details[0].accidentFileNo === choosenCase[0].accidentFileNo);
            if (updatedCase) {
                setChoosenCase([updatedCase]);
            } else {
                setChoosenCase([]);
                setOpenDetails(false)
            }
        }
    }, [data])

    const handleChoosenCase = (item) => {
        setChoosenCase([])
        setChoosenCase([item])
        setOpenDetails(true)
    }

    const getStage = (customerAcceptedVendor, acceptedByAdmin) => {
        return customerAcceptedVendor ? 2 : acceptedByAdmin === 'accept' ? 1 : 0;
    }

    useEffect(() => {
        if (totalCompletedCases.length > 0) {
            const newAvg = Array(data.length).fill(0);
            const newCurrentStage = totalCompletedCases.map((item) => {
                let gotStage = getStage(item.details[0]?.customerAcceptedVendor, item.details[0]?.acceptedByAdmin)
                return gotStage;
            })
            setAvg(newAvg);
            setCurrentStage(newCurrentStage);

            totalCompletedCases.forEach((item, index) => {
                // getVendorLocation(item.crane, item.accidentLatitude, item.accidentLongitude, index);
                // getCustomerRating(item.CustomerCode)
            });
        }
    }, [totalCompletedCases]);


    const containerRef = useRef();

    const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatTimeTo12Hour = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "";

     let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0"); 
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${hours}:${minutes}:${seconds} ${ampm}`;
  };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsHistoryPage(false);
            }
        };

        if (isHistoryPage) {
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = "hidden";
        } else {
      document.body.style.overflow = "auto";
    }
        return () => {
           document.body.style.overflow = "auto";
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isHistoryPage]);

    const getFilteredData = (filter) => {
        console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore);
        const monthBeforeDate = formatDate(monthBefore);

        console.log("todayDate", todayDate);
        console.log("yesterdayDate", yesterdayDate);

        for (let i = 0; i < spareUseData.length; i++) {
            let getTime = spareUseData[i].details[0].filedCaseFullyTime.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here I am daily");
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", spareUseData[i]);
                        filteredData.push(spareUseData[i]);
                    }
                }
            } else if (filter === 'weekly') {
                console.log("here I am weekly");
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            } else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            }
        }

        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            spareUseData.sort((a, b) => {
                const dateA = new Date(a.details[0].filedCaseFullyTime.split('|').join(' '));
                const dateB = new Date(b.details[0].filedCaseFullyTime.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setTotalCompletedCase([...spareUseData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            spareUseData.sort((a, b) => {
                const dateA = new Date(a.details[0].filedCaseFullyTime.split('|').join(' '));
                const dateB = new Date(b.details[0].filedCaseFullyTime.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setTotalCompletedCase([...spareUseData]);
        } else {
            setTotalCompletedCase(filteredData);
        }
    };


    const settingFilter = (filter) => {
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const getVendorLocation = async (crane, accidentLatitude, accidentLongitude, index) => {
        try {
            console.log("disntaceadfafdaf", distance)
            console.log("craninging", crane, accidentLatitude, accidentLongitude, index)

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${crane}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                const calculatedDistance = haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2);
                distance.push(calculatedDistance)
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const getCustomerRating = async (customerCode) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/vendorRatingToCustomer/${customerCode}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                avg.push(response.data.data);
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }

    const [showFilter, setShowFilter] = useState(false);

    const toggleFilter = () => {
        setShowFilter((prev) => !prev);
    };

    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);
        const newRows = spareUseData.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly
            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row.reg ?? '').toLowerCase().includes(searchLower);
            return vehicleNoValue;
        });

        setTotalCompletedCase(newRows);
    };

    const [historyStage, setHistoryStages] = useState([]);
    const [currentHistoryStage, setCurrentHistoryStage] = useState([]);
    const [currentItemIndex, setCurrentItemIndex] = useState(null);

    const getHistoryStage = (connectedVendorFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime) => {
        return [connectedVendorFullyTime, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime]
    }
    const getStageAndHistory = (item, index) => {
        setCurrentItemIndex(index)
        console.log("item", item.details[0].connectedVendorFullyTime)
        let gotStage = getHistoryStage(item?.details[0]?.connectedVendorFullyTime, item?.details[0]?.customerAcceptedVendorTime, item?.details[0]?.vendorMovedTime, item?.details[0]?.vendorReachedTime, item?.details[0]?.doneWorkingTime)
        currentHistoryStage.unshift(gotStage)
        setIsHistoryPage(true)
    }

const formatIST = (utcDateString) => {
  if (!utcDateString) return "N/A";

  const options = {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat('en-IN', options);
  return formatter.format(new Date(utcDateString)).replace(',', ' •');
};



    useEffect(() => {
        if (currentHistoryStage[0]) {
            console.log("currenthistory", currentHistoryStage[0])
            setHistoryStages([
                { label: "Connected", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png', date: formatIST(currentHistoryStage[0][0])},
                { label: "Customer Accepted", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png', date: formatIST(currentHistoryStage[0][1]) },
                { label: "Accepted & Moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png', date: formatIST(currentHistoryStage[0][2]) },
                { label: "Reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/reachedUser.png', date: formatIST(currentHistoryStage[0][3]) },
                { label: "Work Done", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/workDoneUser.png', date: formatIST(currentHistoryStage[0][4]) },
            ]);
        }
    }, [currentHistoryStage[0]]);


    const [searchTerm, setSearchTerm] = useState("");


    useEffect(() => {
    
        const filteredData = data
            .filter((item) =>
                item?.reg
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
            .sort((a, b) => {
                const timeA = Date.parse(a.details?.[0]?.connectedVendorFullyTime || "");
                const timeB = Date.parse(b.details?.[0]?.connectedVendorFullyTime || "");

                if (isNaN(timeA) && isNaN(timeB)) return 0;
                if (isNaN(timeA)) return 1;
                if (isNaN(timeB)) return -1;

                return timeB - timeA; // descending
            });

        if (filteredData && filteredData.length > 0) {
            setTotalCompletedCase(filteredData);
        }
        // else {
        //     setTotalCompletedCase(data);
        // }

        setSpareUseData(data)
        if (choosenCase.length > 0) {
            const updatedCase = data.find((item) => item.details[0].accidentFileNo === choosenCase[0].accidentFileNo);
            if (updatedCase) {
                setChoosenCase([updatedCase]);
            } else {
                setChoosenCase([]);
                setOpenDetails(false)
            }
        }
    }, [data, searchTerm])

const [downloadingItems, setDownloadingItems] = useState(new Set());

const handleVendorInvoiceDownload = async (item) => {
  try { 
    const itemKey = item.accidentVehicleCode || item.AccidentVehicleCode || item.id || 'default';

    setDownloadingItems(prev => new Set([...prev, itemKey]));
    console.log('Starting vendor invoice download for item:', item);

    // Extract the required codes from your item
    const customerCode = item.customerCode || item.CustomerCode || 'default-customer';
    const accidentVehicleCode = item.accidentVehicleCode || item.AccidentVehicleCode || 'default-accident';
    console.log('Using codes:', { customerCode, accidentVehicleCode });
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/getVendorInvoice/${customerCode}/${accidentVehicleCode}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
        },
      }
    );
    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, response: ${errorData}`);
    }

    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Received empty PDF file');
    }

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `vendor_invoice_${accidentVehicleCode}.pdf`;
    document.body.appendChild(a);
    a.click();
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    console.log('Vendor invoice downloaded successfully');
  } catch (error) {
    console.error('Error downloading vendor invoice:', error);
    alert(`Error downloading vendor invoice: ${error.message}`);
  } finally {
    setDownloadingItems(prev => {
      const newSet = new Set(prev);
      const itemKey = item.accidentVehicleCode || item.AccidentVehicleCode || item.id || 'default';
      newSet.delete(itemKey);
      return newSet;
    });
  }
};
    return (
        <div>
            <div style={{
                height: "100vh", background: "white", marginTop:"-1rem"
            }}>
                <div className="container" style={{
                    maxWidth: "500px",
                    // height: "30px",
                    // marginBottom: "30px",
                    // paddingTop: "0px"
                }}>
                    <div className="relative">
                        <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border m-3">
                            <input
                                type="text"
                                className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                placeholder="Search.."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        {showFilter && (
                            <div style={{ boxShadow: '2px 2px 2px' }} className="absolute top-full right-4 transform -translate-y-10 bg-white shadow-xl border rounded-xl w-60 z-50">
                                <ul className="p-2 text-sm">
                                    <li
                                        onClick={() => settingFilter('newest')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <CheckCircle className="w-4 h-4 text-green-500" />
                                        Newest - Oldest
                                    </li>
                                    <li
                                        onClick={() => settingFilter('oldest')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <XCircle className="w-4 h-4 text-red-500" />
                                        Oldest - Newest
                                    </li>
                                    <li
                                        onClick={() => settingFilter('daily')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <CalendarDays className="w-4 h-4 text-blue-500" />
                                        Yesterday
                                    </li>
                                    <li
                                        onClick={() => settingFilter('weekly')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <History className="w-4 h-4 text-indigo-500" />
                                        Last 7 Days
                                    </li>
                                    <li
                                        onClick={() => settingFilter('montly')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <Calendar className="w-4 h-4 text-purple-500" />
                                        Last 30 Days
                                    </li>
                                    <li
                                        onClick={() => settingFilter('year')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <Clock className="w-4 h-4 text-gray-700" />
                                        Year and Before
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
                {totalCompletedCases.length > 0 && (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(330px, 1fr))",

                        }}>
                        {totalCompletedCases.map((item, dataIndex) => (
                            //     <div style={{
                            //         border: "1px solid teal", minWidth: "280px", margin: '10px', boxShadow: 'rgba(0, 0, 0, 0.2) 3px 4px 12px 8px', borderRadius: "20px", padding: "10px",
                            //         backgroundImage: "url('https://m.clw-specialtruck.com/uploads/201919986/20t-wrecker-tow-truck25419630566.jpg')", // ✅ Corrected syntax
                            //         backgroundSize: "cover", // ✅ Ensures the image covers the container
                            //         backgroundPosition: "center", // ✅ Centers the image
                            //         backgroundRepeat: "no-repeat", // ✅ Prevents tiling  
                            //     }}>

                            //         <div className="bg-gray-400 p-1" style={{borderRadius:'10px', opacity:'0.9'}}>

                            //             <div style={{ display: "flex", alignItems: "center", margin: "20px 0px 0px 0px" }}>
                            //                 {stages.map((stage, index) => (
                            //                     <div
                            //                         key={index}
                            //                         style={{
                            //                             display: "flex",
                            //                             flexDirection: "column",
                            //                             alignItems: "center",
                            //                             textAlign: "center",
                            //                             position: "relative",
                            //                             flex: 1,
                            //                         }}
                            //                     >
                            //                         {/* Icon/Image for each stage */}
                            //                         <div
                            //                             style={{
                            //                                 width: "30px",
                            //                                 height: "30px",
                            //                                 borderRadius: "50%",
                            //                                 backgroundColor: index === currentStage[dataIndex] ? index === 2 ? "rgb(11 219 255)" : "#4CAF50" : "#ccc",
                            //                                 display: "flex",
                            //                                 alignItems: "center",
                            //                                 justifyContent: "center",
                            //                                 border: index === currentStage[dataIndex] ? "2px solid #4CAF50" : "none",
                            //                                 transition: "background-color 0.3s ease",
                            //                                 zIndex: 1,
                            //                             }}
                            //                         >
                            //                             <img
                            //                                 src={stage.img}
                            //                                 alt={stage.label}
                            //                                 style={{
                            //                                     width: "20px",
                            //                                     height: "20px",
                            //                                     opacity: index <= currentStage[dataIndex] ? 1 : 0.5,
                            //                                 }}
                            //                             />
                            //                         </div>

                            //                         {/* Stage Label */}
                            //                         <p
                            //                             style={{
                            //                                 marginTop: "5px",
                            //                                 color: index <= currentStage[dataIndex] ? "black" : "#aaa",
                            //                                 fontWeight: index === currentStage[dataIndex] ? "bold" : "normal",
                            //                                 fontSize: "12px",
                            //                             }}
                            //                         >
                            //                             {stage.label}
                            //                         </p>

                            //                         {/* Connecting Line */}
                            //                         {index < stages.length - 1 && (
                            //                             <div
                            //                                 style={{
                            //                                     position: "absolute",
                            //                                     top: "15px", // Aligns with the center of the icon
                            //                                     left: "50%",
                            //                                     right: "-50%",
                            //                                     width: "100%",
                            //                                     height: "2px",
                            //                                     backgroundColor: index < currentStage[dataIndex] ? "#4CAF50" : "#ccc",
                            //                                     zIndex: 0,
                            //                                 }}
                            //                             ></div>
                            //                         )}
                            //                     </div>
                            //                 ))}
                            //             </div>

                            //             <div style={{ marginTop: "20px" }}>

                            //                 {/* <hr className="color-black m-0" /> */}
                            //                 <div className='px-2 py-1 ' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                            //                     <div style={{ display: "flex", alignItems: "center" }}>
                            //                         <LocalShippingOutlinedIcon className='h-[30px] w-[30px]' />
                            //                         <span className='text-md font-semibold' style={{ marginLeft: "5px" }}>{item.details[0].reg}</span>
                            //                     </div>
                            //                     <div
                            //                         className="right-10  flex items-center mt-1"
                            //                         style={{ margin: '0px 5px 0 5px' }}
                            //                     >
                            //                         <ArticleIcon className="h-[30px] w-[30px] text-red-500" />
                            //                         <span className="text-xs font-medium ml-2">
                            //                             {item.details[0].systemDate?.split("|")[0]}
                            //                         </span>
                            //                     </div>
                            //                 </div>



                            //                 <div style={{ borderTop: '1px solid gray', borderRadius: "10px 0px 0px 10px", borderBottom: "1px solid", padding: '4px 5px 9px 5px', display: 'inline-block', background: "linear-gradient(42deg, #e7fae8, transparent)", margin: '10px' }}>
                            //                     <div style={{ display: "flex", alignItems: "center", margin: '10px 5px 0px 15px' }}>
                            //                         <LibraryAddCheckIcon className='h-[30px] w-[30px] text-red-500' />
                            //                         <span className="text-sm font-semibold" style={{ marginLeft: "5px" }}>Task Completed</span>
                            //                     </div>

                            //                     <div style={{ display: "flex", alignItems: "center", margin: '5px 5px 0px 15px' }}>
                            //                         <DateRangeOutlinedIcon className='h-[30px] w-[30px]  text-red-500' />
                            //                         <p className="text-sm ml-2 text-green-700">Date</p>
                            //                         <span className="text-sm" style={{ marginLeft: "5px" }}>{item.details[0].confirmDoneWorkingTime?.split("|")[0]}</span>

                            //                         <AccessTimeOutlinedIcon className='h-[30px] w-[30px] text-red-500 ml-5' />
                            //                         <span className="text-sm" style={{ marginLeft: "5px" }}>{item.details[0].confirmDoneWorkingTime?.split("|")[1]}</span>
                            //                     </div>
                            //                 </div>


                            //             </div>

                            //             {/* <div style={{
                            //     fontSize: '11px',
                            //     marginTop: "2px",
                            //     background: "white",
                            //     padding: "10px",
                            //     border: '2px solid #000000',
                            //     textAlign: 'center',
                            //     borderRadius: '30px',
                            //     fontWeight: "bold",
                            //     color: "blue",
                            //     display: 'flex',
                            //     alignItems: 'center',
                            //     justifyContent: "center",
                            //     position: "relative",
                            //     cursor: "pointer",
                            //     maxWidth: "400px",
                            //     minWidth: "280px",
                            //     margin: '5px 0px 0px 5px',
                            //     height: "30px"
                            // }}
                            //     onClick={() => handleChoosenCase(item)}>View Case</div> */}
                            //         </div>

                            //         <div className="mt-2 ml-auto flex justify-end">
                            //                     <p
                            //                         className="text-sm mt-1 font-semibold bg-red-600 text-white   text-center rounded-full  flex items-center justify-center relative cursor-pointer max-w-[200px] min-w-[150px] h-[30px]"
                            //                         style={{ border: '1px solid', paddingLeft: "10px", fontSize: "13px" }}
                            //                         onClick={(e) => getStageAndHistory(item, dataIndex)}
                            //                     >
                            //                         See History
                            //                         <img
                            //                             src={historyUser}
                            //                             className="absolute left-1 h-[20px] w-[20px]"
                            //                             alt="history icon"
                            //                         />
                            //                     </p>
                            //                 </div>


                            //     </div>

                            <div style={{ border: '1px solid ', boxShadow: '3px 2px 0px 0px' }} className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] pb-[1rem] px-[2rem] rounded-[12px]  m-3">
                                <div className="bg-white p-1" style={{ borderRadius: '10px', opacity: '0.9' }}>
                                    <div className="flex items-center justify-between">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className="h-[100px] w-[100px]" alt="vehicle" />
                                        <div className="grid-cols-2 sm:grid-cols-2 gap-x-[2rem] gap-y-[1rem] mt-[1.5rem] p-2">
                                            {[
                                                {
                                                    title: item.reg,
                                                    subtitle: "Vehicle No",
                                                },
                                                {
                                                     title: (
                                                  <div className="flex flex-col">
                                                    <span>
                                                      {formatDateToDDMMYYYY(
                                                        item.details[0].confirmDoneWorkingTime
                                                      )}
                                                    </span>
                                                    <span className="text-xs text-gray-600">
                                                      {formatTimeTo12Hour(
                                                        item.details[0].confirmDoneWorkingTime
                                                      )}
                                                    </span>
                                                  </div>
                                                    ),
                                                    subtitle: "Closed Date",
                                                }

                                            ].map((block, idx) => (
                                                <div key={idx} className="flex flex-col  mb-2">
                                                    <h6 className="m-0 font-[700] font-satoshi text-lg sm:text-xl md:text-2xl text-[#0A0119] pb-[6px] leading-tight truncate">
                                                        {block.title}
                                                    </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-sm sm:text-base text-[#515151] leading-snug">
                                                        {block.subtitle}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                
                 {/* Invoice Download */}

                <div className="flex items-center mt-4">
                  <button 
                    className="flex items-center ml-36 gap-2 rounded-full py-1 px-3 bg-green-500 text-white text-sm disabled:bg-gray-400 disabled:cursor-not-allowed" 
                    onClick={() => handleVendorInvoiceDownload(item)}
                    disabled={downloadingItems.has(item.accidentVehicleCode || item.AccidentVehicleCode || item.id || 'default')}
                  > 
                    {downloadingItems.has(item.accidentVehicleCode || item.AccidentVehicleCode || item.id || 'default') ? (

                      <>
                        <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"
                      //   style={{
                      //   width: '12px',
                      //   height: '12px',
                      //   border: '2px solid white',
                      //   borderTopColor: 'transparent',
                      //   borderRadius: '50%',
                      //   animation: 'spin 1s linear infinite'
                      // }}
                      >
                      <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" stroke="currentColor" stroke-width="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      </div>
                        <span>Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download size={14} />
                        <span>Invoice</span>
                      </>
                    )}
                  </button>
                </div>

                                <button onClick={(e) => getStageAndHistory(item, dataIndex)} className="bg-[#21A6E9] py-[3px] px-[4px] w-full text-center mt-[18px] rounded-full text-[#FFFFFF] font-satoshi font-[400] text-[18px] sm:text-[24px] leading-[33.6px]">
                                    View History
                                </button>
                            </div>

                        ))}
                    </div>
                )}

                {openDetails && (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                        zIndex: 1001,
                        display: "flex",
                        alignItems: "flex-end", // positions the container at the bottom
                        justifyContent: "center",
                        animation: "slideUp 0.5s ease-out",
                    }}>

                        <div className="image-container" >
                            <div className="background-image"></div>
                            <img
                                src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crossUser.png'
                                onClick={() => setOpenDetails(false)}
                                style={{
                                    position: "fixed",
                                    // top: "-10px",
                                    left: "calc(100% - 80px)",
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                    zIndex: 1001,
                                    filter: "drop-shadow(0 0 5px rgba(255, 255, 255, 0.5))",
                                    bottom: "360px"
                                }}
                            />
                            <VendorMoving item={choosenCase[0]} />
                        </div>
                    </div>
                )}
                {totalCompletedCases.length === 0 && (
                    <NoDataFound />
                )}


                <Modal isOpen={openFilterModal} onClose={() => setOpenFilterModal(!openFilterModal)}>
                    {openFilterModal && (
                        <div style={{ textAlign: "center", marginTop: "30px", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('newest') }}>newest to oldest</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('oldest') }}>oldest to newest</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('daily') }}>Yesterday</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('weekly') }}>Last 7 days</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('monthly') }}>Last 30 days</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('year') }}>Year</p>
                        </div>
                    )}
                </Modal>

            </div>

            <div
            >


                {isHistoryPage && (
                    <div
                        className="font-satoshi"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                            zIndex: 1000,
                            display: "flex",
                            alignItems: "flex-end", // positions the container at the bottom
                            justifyContent: "center",
                            animation: "slideUp 0.5s ease-out",
                        }}
                    >
                        {/* Modal Container */}
                        <div
                            style={{
                                position: "relative",
                                width: "97%",
                                maxWidth: "600px",
                                backgroundColor: "#fff", // white background for the content
                                borderRadius: "15px 15px 0px 0px",
                                // marginBottom: "30px",
                                maxHeight: "80%", // limit the height for scrollability
                                overflowY: "auto", // enables vertical scrolling
                                padding: "20px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                            }}
                        >
                            {/* Cross Icon */}


                            <div ref={containerRef} style={{ display: "flex", flexDirection: "row", gap: '30px', alignItems: "center", justifyContent: 'center', margin: "20px 0px" }}>
                                <div>
                                    {historyStage.map((stage, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column", // Stack vertically
                                                alignItems: "center",
                                                position: "relative", // Needed for absolute positioning of the line
                                                marginBottom: "20px", // Space between stages
                                                flex: 1,
                                            }}
                                        >
                                            {/* Icon/Image for each stage */}
                                            <div
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "2px solid #4CAF50",
                                                    transition: "background-color 0.3s ease",
                                                    zIndex: 1, // **Changed: Make sure image is above the line**
                                                }}
                                            >
                                                <img
                                                    src={stage.img}
                                                    alt={stage.label}
                                                    style={{
                                                        width: "20px",
                                                        height: "20px",
                                                        opacity: 1,
                                                    }}
                                                />
                                            </div>

                                            {/* Date next to the image */}
                                            <div
                                                style={{
                                                    marginTop: "5px", // Space between icon and date
                                                    color: "black",
                                                    fontSize: "12px",
                                                    fontWeight: "normal",
                                                }}
                                            >
                                                {stage.date}
                                            </div>

                                            {/* Stage Label */}
                                            <div
                                                style={{
                                                    marginTop: "5px", // Space between date and label
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {stage.label}
                                            </div>

                                            {index < historyStage.length - 1 && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "100%", // **Changed: Position the line below the image and date**
                                                        left: "50%",
                                                        width: "2px",
                                                        height: "20px", // **Changed: Adjust this value as needed for spacing**
                                                        backgroundColor: "#4CAF50",
                                                        transform: "translateX(-50%)", // **Changed: Center the line between images**
                                                        zIndex: 0, // **Changed: Make sure the line is behind the content**
                                                    }}
                                                ></div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default CraneCompletedOrders;